import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { take } from 'rxjs/operators';

export interface ExportFilenamePrompt {
  defaultFilename: string;
  result: Subject<string>;
}

@Injectable({
  providedIn: 'root',
})
export class ExportFilenameService {
  private promptSubject = new Subject<ExportFilenamePrompt>();
  public prompts$ = this.promptSubject.asObservable();

  // Emits the confirmed filename, or null if the user cancelled. Completes after one emission.
  public prompt(defaultFilename: string): Observable<string> {
    const result = new Subject<string>();
    this.promptSubject.next({ defaultFilename, result });
    return result.asObservable().pipe(take(1));
  }

  public sanitizeFilename(filename: string): string {
    return (filename || '')
      .trim()
      .replace(/[\\/:*?"<>|]+/g, '-')
      .replace(/\s+/g, ' ');
  }
}
